/**
 * User at work class
 */
export class UserAtWork {
    public name: string;
    public surname: string;
    public pictureUrl: string;
    public timeregIn: number;
    public timeregOut: number;
    public timeregExactIn: number;
    public timeregExactOut: number;
    public scheduledTimegIn: number;
    public scheduledTimegOut: number;
    public totalWorkedHours: number;
    public status: string;
    public civilRegNumber: string;
    public workStatus: string;
    public timeregIsDeleted : boolean;
}



// WEBPACK FOOTER //
// ./src/models/userAtWork.ts